import axios from 'axios';
import { EndPoints } from './APIEndpoints';
import { AddInLocalStorage, Error, GetFromLocalStorage, IsObjectEmpty, IsStringEmpty, Log } from '../utilities/CommonMethods';
import { ParsedError, ParsedNotificationList } from './DataParser';
import Constants from '../utilities/Constants';
import { APICodes } from './APICodes';
import defaultAvatar from '../assets/icons/default-avatar.png';
import SortHelper from '../utilities/SortHelper';

const userLogin = async (username, pwd) => {
    //Log("UserAPIController -> userlogin -> ", username, pwd);
    let response = await axios.post(EndPoints.LOGIN_URL, { username: username, password: pwd })
        .then((response) => {
            // Log('Login Success: ', response);

            let profilePic = !IsStringEmpty(response.data.user.profilepicture_url) ? response.data.user.profilepicture_url : defaultAvatar;

            const fullName = !IsStringEmpty(response.data.user.first_name) ? (response.data.user.first_name + ' ' + response.data.user.last_name) : '';

            const isLearner = response.data.user.user_category === 'student' ? true : false;
            const isProgramManager = response.data.user.user_category === 'pm' ? true : false;

            AddInLocalStorage(Constants.KEY_IS_LEARNER, isLearner);
            AddInLocalStorage(Constants.KEY_IS_PROGRAM_MANAGER, isProgramManager);

            const parsedObj = {
                userDetails: {
                    profilePic: profilePic,
                    username: response.data.user.username,
                    userId: response.data.user.id,
                    email: response.data.user.email,
                    fullName: fullName,
                    userCategory: response.data.user.user_category,
                    isLearner: isLearner,
                    isProgramManager: isProgramManager,
                    unreadNotifCount: response.data.unread_notification_count
                },
                token: response.data.token
            }
            response.data = parsedObj;
            return response
        })
        .catch((error) => {
            Log('Login Error: ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.LOGIN_URL, APICodes.SIGN_IN)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const userLogout = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.LOGOUT_URL, { headers: { 'Authorization': token } })
        .then((res) => {
            // Log('Logout Success: ', res);
            return res
        })
        .catch((error) => {
            Log('Logout Error: ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.LOGOUT_URL, APICodes.LOG_OUT)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const getAllNotifications = async (forDropdown) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.GET_ALL_NOTIFICATIONS(''), { headers: { 'Authorization': token } })
        .then((response) => {
            // Log('Get All Notifications Success: ', response);

            const parsedNotifications = ParsedNotificationList(response.data.all_notifications, forDropdown);

            const totalPages = Math.round(response.data.count / 20); // Total Notifications per page = 20
            // console.log("Response ===>>>", response.data.next, response.data.count);

            const nextPageNum = !IsStringEmpty(response.data.next) ? response.data.next.split("=")[1] : totalPages;

            let parsedObj = {
                updatedNotificationsList: SortHelper.sortNotificationsByMostRecent(parsedNotifications),
                unreadNotifCount: response.data.unread_count_notifications,
                nextPageUrl: response.data.next,
                previousPageUrl: response.data.previous,
                totalPages: totalPages,
                nextPage: nextPageNum
            }

            response.data = parsedObj;

            return response;
        })
        .catch((error) => {
            Log('Get All Notifications Error: ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.LOGOUT_URL, APICodes.LOG_OUT)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const getPagewiseNotifications = async (forDropdown, pageNum) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.GET_ALL_NOTIFICATIONS(pageNum), { headers: { 'Authorization': token } })
        .then((response) => {
            // Log('getPagewiseNotifications Success: ', response);

            const parsedNotifications = ParsedNotificationList(response.data.all_notifications, forDropdown);

            const totalPages = Math.round(response.data.count / 20); // Total Notifications per page = 20

            // console.log("Response ===>>>", response.data.next);
            const nextPageNum = !IsStringEmpty(response.data.next) ? response.data.next.split("=")[1] : totalPages;

            let parsedObj = {
                updatedNotificationsList: SortHelper.sortNotificationsByMostRecent(parsedNotifications),
                unreadNotifCount: response.data.unread_count_notifications,
                nextPageUrl: response.data.next,
                previousPageUrl: response.data.previous,
                totalPages: totalPages,
                nextPage: nextPageNum
            }

            response.data = parsedObj;

            return response;
        })
        .catch((error) => {
            Log('getPagewiseNotifications Error: ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.LOGOUT_URL, APICodes.LOG_OUT)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const getDropdownNotifications = async (forDropdown) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.GET_DROPDOWN_NOTIFICATIONS, { headers: { 'Authorization': token } })
        .then((response) => {
            // Log('Get getDropdownNotifications Success: ', response);

            const parsedNotifications = ParsedNotificationList(response.data.all_notifications, forDropdown);

            let parsedObj = {
                updatedNotificationsList: SortHelper.sortNotificationsByMostRecent(parsedNotifications),
                unreadNotifCountTotal: !IsStringEmpty(response.data.unread_count_total) ? response.data.unread_count_total : 0,
                unreadNotifCountAnnouncement: !IsStringEmpty(response.data.unread_count_announcement) ? response.data.unread_count_announcement : 0,
                unreadNotifCountImportant: !IsStringEmpty(response.data.unread_count_important) ? response.data.unread_count_important : 0,
                unreadNotifCountNotification: !IsStringEmpty(response.data.unread_count_notification) ? response.data.unread_count_notification : 0,
            }

            response.data = parsedObj;

            return response;
        })
        .catch((error) => {
            Log('Get getDropdownNotifications Error: ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.LOGOUT_URL, APICodes.LOG_OUT)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const getRecentNotifications = async (forDropdown) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.GET_RECENT_NOTIFICATIONS, { headers: { 'Authorization': token } })
        .then((response) => {
            // Log('Get getDropdownNotifications Success: ', response);

            const parsedNotifications = ParsedNotificationList(!IsObjectEmpty(response.data.notification_data) ? [response.data.notification_data] : [], forDropdown);

            let parsedObj = {
                updatedNotificationsList: SortHelper.sortNotificationsByMostRecent(parsedNotifications),
                unreadNotifCountTotal: !IsStringEmpty(response.data.unread_count_total) ? response.data.unread_count_total : 0
            }

            response.data = parsedObj;

            return response;
        })
        .catch((error) => {
            Log('Get getDropdownNotifications Error: ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.LOGOUT_URL, APICodes.LOG_OUT)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const getFilteredNotifications = async (filter) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.GET_FILTERED_NOTIFICATIONS(filter), { headers: { 'Authorization': token } })
        .then((response) => {
            // Log('Get Filtered Notifications Success: ', response);

            const parsedNotifications = ParsedNotificationList(response.data.all_notifications, false);

            let parsedObj = {
                updatedNotificationsList: SortHelper.sortNotificationsByMostRecent(parsedNotifications),
                unreadNotifCount: response.data.unread_count_notifications
            }

            response.data = parsedObj;

            return response;
        })
        .catch((error) => {
            Log('Get Filtered Notifications Error: ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.LOGOUT_URL, APICodes.LOG_OUT)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const markNotificationAsRead = async (notificationId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.MARK_NOTIFICATION_AS_READ(notificationId), { headers: { 'Authorization': token } })
        .then(res => {
            // Log('MARK_NOTIF_READ Response: ', res.data);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.MARK_NOTIFICATION_AS_READ)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const markAllNotificationsAsRead = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.MARK_ALL_NOTIFICATIONS_AS_READ, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('MARK_ALL_NOTIFS_READ Response: ', res.data);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.MARK_ALL_NOTIFICATIONS_AS_READ)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const userForgotPassword = async (userEmail) => {
    // Log("UserAPIController -> userforgotpassword -> ", userEmail);
    let response = await axios.post(EndPoints.FORGOT_PASSWORD_URL, userEmail)
        .then((res) => {
            // Log('FORGOT_PASSWORD_URL Success: ', res);
            return res
        })
        .catch((error) => {
            Error('FORGOT_PASSWORD_URL Error : ', error.response.data.error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.FORGOT_PASSWORD_URL)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const resetPassword = async (FormData) => {
    let response = await axios.post(EndPoints.RESET_PASSWORD_URL, FormData)
        .then((res) => {
            // Log('Success: ', res);
            return res
        })
        .catch((error) => {
            Error('ResetPasswordError : ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.RESET_PASSWORD_URL, APICodes.RESET_PASSWORD)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}


const changePassword = async (FormData) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.CHANGE_PASSWORD, FormData, { headers: { 'Authorization': token } })
        .then((res) => {
            // Log('Success: ', res);
            return res
        })
        .catch((error) => {
            Error('userChangePasswordError : ', error.response.data.error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.CHANGE_PASSWORD, APICodes.CHANGE_PASSWORD)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const updateProfilePic = async (formData, userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    if (!IsStringEmpty(userToken)) {
        token = 'Token ' + userToken;
    }
    let response = await axios.post(EndPoints.UPDATE_LEARNER_PROFILE, formData, { headers: { Authorization: token } })
        .then((res) => {
            // Log('UPDATE_LEARNER_PROFILE Success: ', res);
            return res
        })
        .catch((error) => {
            Error('updateProfilePic ERROR: ', error.response.data.error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.UPDATE_LEARNER_PROFILE)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const updateJobProfile = async (userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    if (!IsStringEmpty(userToken)) {
        token = 'Token ' + userToken;
    }

    let response = await axios.get(EndPoints.UPDATE_JOB_PROFILE, { headers: { Authorization: token } })
        .then((res) => {
            // Log('UPDATE_JOB_PROFILE Success: ', res);
            return res
        })
        .catch((error) => {
            Error('updateProfilePic ERROR: ', error.response.data.error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.UPDATE_JOB_PROFILE)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const updateProfileSkills = async (data, userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    if (!IsStringEmpty(userToken)) {
        token = 'Token ' + userToken;
    }

    let response = await axios.post(EndPoints.PROFILE_PAGE_DATA, data, { headers: { 'Authorization': token } })
        .then(res => {
            Log(res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.PROFILE_PAGE_DATA)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const UserAPIController = {
    userLogin, userLogout, getAllNotifications, getFilteredNotifications,
    markNotificationAsRead, userForgotPassword, resetPassword, changePassword, updateProfilePic,
    markAllNotificationsAsRead, updateJobProfile, getDropdownNotifications, updateProfileSkills, getPagewiseNotifications, getRecentNotifications
}

export default UserAPIController
